import Api from './Api';

export default class BrandsAPIs extends Api {
  getAllBrands(accessToken) {
    return this.instance.get('brands', this.constructor.addAuthorizationHeader(accessToken));
  }
}
